module.exports = __webpack_public_path__ + "static/media/42_tn.9b9ba560.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/borders/thumbnails/42_tn.jpg
// module id = 678
// module chunks = 0